export default __webpack_public_path__ + "static/media/audiov2_double_sided_demo.617731dd.mp4";